import { RuleDefinitionData } from '~/services/PublicOfferFeedService';

export type MetricKey = keyof NonNullable<RuleDefinitionData>;

export const RULE_HEADINGS: Record<MetricKey, string> = {
  spend: 'Spend (AUD)',
  margin: 'Margin (AUD)',
  mpv: 'Margin Per View (AUD)',
  views: 'Views',
  clicks: 'Clicks',
  impressions: 'Impressions',
  ctr: 'CTR',
  cpc: 'CPC',
  impression_share: 'Impression Share',
  mroas: 'Margin Roas',
  conversion_value: 'Conversion Value',
  conversions: 'Conversions',
  margin_per_view_change_3d_vs_7d_pct: 'Percentage of Margin per view change from 3 days to 7 days',
  margin_per_view_change_1d_vs_7d_pct: 'Percentage of Margin per view change from 1 days to 7 days',
  conversion_rate_change_3d_vs_7d_pct: 'Percentage of Conversion rate change from 3 days to 7 days',
  conversion_rate_change_1d_vs_7d_pct: 'Percentage of Conversion rate change from 1 days to 7 days',
};

export const ALL_METRICS_SECTION: Array<MetricKey> = [
  'spend',
  'margin',
  'mpv',
  'views',
  'clicks',
  'impressions',
  'ctr',
  'cpc',
  'impression_share',
  'mroas',
  'conversion_value',
  'conversions',
];

export const SEARCH_METRICS_SECTION: Array<MetricKey> = [
  'margin_per_view_change_3d_vs_7d_pct',
  'margin_per_view_change_1d_vs_7d_pct',
  'conversion_rate_change_3d_vs_7d_pct',
  'conversion_rate_change_1d_vs_7d_pct',
];
